import { render, staticRenderFns } from "./selectGateSpace.vue?vue&type=template&id=2d2bc830&scoped=true"
import script from "./selectGateSpace.vue?vue&type=script&lang=js"
export * from "./selectGateSpace.vue?vue&type=script&lang=js"
import style0 from "./selectGateSpace.vue?vue&type=style&index=0&id=2d2bc830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2bc830",
  null
  
)

export default component.exports